// extracted by mini-css-extract-plugin
module.exports = {"adslot":"AdInsideList_adslot__xT_Vj"};